import { useApi } from '@/contexts/ApiContext'

const unwrap = async <T = any>(promise: Promise<any>): Promise<T> => {
  const res = await promise
  return (res && res.data) ?? res
}

/**
 * Adapter between Machine pages and generated MachineApi.
 * Стремимся сохранить старые имена методов, чтобы минимально менять UI.
 */
export function useMachineService() {
  const { MachineApi } = useApi()

  /* ----------------------------- BASIC CRUD ----------------------------- */
  const getMachine = (id: string) => unwrap((MachineApi as any).getMachine ? (MachineApi as any).getMachine(id) : (MachineApi as any).machineIdGet?.(id))

  const listMachines = async (params: any = {}) => {
    const fn = (MachineApi as any).listMachines ? (MachineApi as any).listMachines : (MachineApi as any).machineListGet
    const res: any = await unwrap(fn.call(MachineApi, params.limit ?? 100, params.offset ?? 0))
    // OpenAPI: { machines: { machines: [] }, pagination }
    if (Array.isArray(res)) return res
    if (res?.machines?.machines) return res.machines.machines
    if (res?.machines) return res.machines
    return []
  }

  const getMachines = listMachines

  const createMachine = (machine: any) => unwrap((MachineApi as any).createMachine ? (MachineApi as any).createMachine(machine) : Promise.reject('createMachine not implemented'))

  const updateMachine = (id: string, updates: any) => unwrap((MachineApi as any).updateMachine ? (MachineApi as any).updateMachine(id, updates) : Promise.reject('updateMachine not implemented'))

  const deleteMachine = (id: string) => unwrap((MachineApi as any).deleteMachine ? (MachineApi as any).deleteMachine({ id }) : Promise.reject('deleteMachine not implemented'))

  const cloneMachine = (sourceId: string, newId: string, newName: string) => unwrap((MachineApi as any).cloneMachine({ source_id: sourceId, new_id: newId, new_name: newName }))

  /* ----------------------------- SESSION OPS --------------------------- */
  const reserveMachine = (machineId: string, userId: string) => unwrap((MachineApi as any).reserveMachine({ machine_id: machineId, user_id: userId }))
  const releaseMachine = (sessionId: string) => unwrap((MachineApi as any).releaseMachine({ session_id: sessionId }))

  /* ------------------------- FINANCIAL OPS ----------------------------- */
  const topUpMachine = (payload: any) => unwrap((MachineApi as any).topUpMachine ? (MachineApi as any).topUpMachine(payload) : Promise.reject('topUpMachine not implemented'))
  const cashOutMachine = (payload: any) => unwrap((MachineApi as any).cashOutMachine(payload))

  /* ------------------------- STATE OPS ---------------------------- */
  const enableMachine = (id: string) => unwrap((MachineApi as any).enableMachine ? (MachineApi as any).enableMachine(id) : Promise.reject('enableMachine not implemented'))
  const disableMachine = (id: string) => unwrap((MachineApi as any).disableMachine ? (MachineApi as any).disableMachine(id) : Promise.reject('disableMachine not implemented'))

  return {
    getMachine,
    listMachines,
    getMachines,
    createMachine,
    updateMachine,
    deleteMachine,
    cloneMachine,
    reserveMachine,
    releaseMachine,
    topUpMachine,
    cashOutMachine,
    enableMachine,
    disableMachine,
  }
} 